import dgorder from './dgorder'
import dgorderCart from './dgorderCart'
import purchase from './purchase'
import dgorderAddress from './dgorderAddress'
import logistics from './logistics'
import dgorderRefund from './dgorderRefund'
import mxdg from './mxdg'
import mxdgCart from './mxdgCart'
import dgorderAliww from './dgorderAliww'
import tradeRefund from './tradeRefund'
import product from './product'
import dgorderRating from './dgorderRating'
import dgorderRepurchase from './dgorderRepurchase'
import dgorderStats from './dgorderStats'
import favorite from './favorite'
import ai from './ai'
import chat from './chat'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    dgorder,
    dgorderCart,
    purchase,
    dgorderAddress,
    logistics,
    dgorderRefund,
    mxdg,
    mxdgCart,
    dgorderAliww,
    tradeRefund,
    product,
    dgorderRating,
    dgorderRepurchase,
    dgorderStats,
    favorite,
    ai,
    chat,
  }
}
